import React from 'react';
import './ReportButtons.css';

const ReportButtons = ({ onPrint }) => {
    const handlePrint = () => {
        if (onPrint) {
            onPrint();
        } else {
            // Fallback: direct window.print() if no custom handler provided
            window.print();
        }
    };

    return (
        <div className="report-buttons-container">
            <button type="submit" className="confirm-button">Bestätigen</button>
            <button type="button" className="print-button" onClick={handlePrint}>Drucken</button>
        </div>
    );
};

export default ReportButtons; 
